module.exports = __webpack_public_path__ + "img/down_white.f933f504.svg";